import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'wellcreatefilter'
})

export class WellCreateFilterPipe implements PipeTransform {

  transform(value: any, input: string, trigger: any) {
        if (input) {
            input = input.toLowerCase();
            return value.filter(function (obj: any) {
                if ((obj.wellName.toLowerCase().indexOf(input) > -1) || (String(obj.wellID).toLowerCase().indexOf(input) > -1)) {
                    return obj
                }
            })
        }

        return value;
    }
}
